var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHalfStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.47 16.1562L16.4026 18.5625L15.3726 14.0625L18.837 11.0625L14.2802 10.6563L12.47 6.40625V0L15.9656 8.28125L24.9544 9.0625L18.1504 14.9688L20.1791 23.75L12.47 19.0938V16.1562Z",
    fill: "#909090"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4844 16.1562L8.55178 18.5625L9.58175 14.0625L6.11732 11.0625L10.6741 10.6563L12.4844 6.40625V0L8.98874 8.28125L-4.57764e-05 9.0625L6.80396 14.9688L4.77524 23.75L12.4844 19.0938V16.1562Z",
    fill: "#FFBF1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHalfStar);
export default __webpack_public_path__ + "static/media/half-star.8ad3dccdbe61898424adf90859786aae.svg";
export { ForwardRef as ReactComponent };